// extracted by css-extract-rspack-plugin
export default {"avatar":"OHCRi","placeholder":"hTchZ","img":"SD2vc"};